import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import IntentRulesPage from "./ui";

const IntentRules = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <IntentRulesPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default IntentRules;

